import styled from "styled-components";

const BrandContainer = styled.div`
  display: flex;
  padding: 100px 0px 150px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  background: black;
  .brand-title {
    color: ${(props) => props.theme.colors.primary.contrast};
    text-align: center;
    font-family: Mulish;
    font-size: 100px;
    font-style: normal;
    font-weight: 600;
    line-height: 100px;
    max-width: 1200px;
    margin: 0;
  }
  .brand-description {
    color: ${(props) => props.theme.colors.primary.contrast};
    text-align: center;
    font-family: Mulish;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    max-width: 1000px;
    margin: 0;
  }
  .brand-wrapper {
    display: flex;
    width: 1730px;
    padding-bottom: 50px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;
  }
  .brands-container-desktop {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    gap: 50px 125px;
    align-self: stretch;
    flex-wrap: wrap;
  }
  .brand-image {
    width: 150px;
    height: auto;
  }

  .brands-container-mobile {
    display: none;
  }

  @media screen and (max-width: 1024px) {
    display: flex;
    padding: 0;
    padding-bottom: 50px;
    padding-top: 74px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    align-self: stretch;
    .brand-wrapper {
      display: flex;
      padding: 0px 30px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 50px;
      align-self: stretch;
      width: 100%;
    }
    .brand-title {
      color: ${(props) => props.theme.colors.primary.contrast};
      text-align: center;
      font-family: Mulish;
      font-size: 35px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
    .brand-description {
      color: ${(props) => props.theme.colors.primary.contrast};
      text-align: center;
      font-family: Mulish;
      font-size: 25px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.411px;
    }
    .brands-container-desktop {
      display: none;
    }
    .brands-container-mobile {
      display: block;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      gap: 20px;
      align-self: stretch;
      flex-wrap: wrap;
      padding: 0px 10px;
    }
    .brand-logo-mobile-1 {
      width: 134.896px;
      height: 50px;
    }
    .brand-logo-mobile-2 {
      width: 122.222px;
      height: 40px;
    }
    .brand-logo-mobile-3 {
      width: 85px;
      height: 20px;
    }
    .brand-logo-mobile-4 {
      width: 105px;
      height: 35px;
    }
    .brand-logo-mobile-5 {
      width: 66.023px;
      height: 35px;
    }
    .brand-logo-mobile-6 {
      width: 35px;
      height: 35px;
    }
    .brand-logo-mobile-7 {
      width: 60.674px;
      height: 60px;
    }
    .brand-logo-mobile-8 {
      width: 143.59px;
      height: 35px;
    }
    .brand-logo-mobile-9 {
      width: 63.519px;
      height: 35px;
    }
  }
`;

export default BrandContainer;
